import { loadRouteLocation } from "vue-router";

const pendingPreloads = new Map();

function connectionAllowsPreload(connection = globalThis.navigator?.connection) {
    if (!connection) return true;
    if (connection.saveData) return false;
    return !["slow-2g", "2g"].includes(connection.effectiveType);
}

/**
 * Load a lazy route component when a navigation control shows intent.
 *
 * This only downloads route code. It does not fetch page data or trigger route
 * guards, so hovering through the navigation cannot create API traffic.
 */
export function preloadRoute(router, to, connection) {
    if (!router || !to || !connectionAllowsPreload(connection)) {
        return Promise.resolve(false);
    }

    const route = router.resolve(to);
    if (!route.matched.length || route.fullPath === router.currentRoute.value.fullPath) {
        return Promise.resolve(false);
    }

    const key = route.matched.map((record) => record.path).join("|");
    if (pendingPreloads.has(key)) return pendingPreloads.get(key);

    const preload = loadRouteLocation(route)
        .then(() => true)
        .catch(() => false)
        .finally(() => pendingPreloads.delete(key));

    pendingPreloads.set(key, preload);
    return preload;
}

export { connectionAllowsPreload };
